export enum errorsEnum {
  FACTOR_NOT_FOUND = 'not found factors',
  TAXDATA_NOT_FOUND = 'TaxaData not found',
  INDEX_NOT_FOUND = 'Index not found',
  DETAILED_NOT_FOUND = 'not found detailed',
  MEMCALC_NOT_FOUND = 'not found memcalc',
  AUTHORS_NOT_FOUND = 'not found authors',
  FACTOR_DETAILED_NOT_FOUND = 'not found factors and detailed',
  DEFAULT = 'Ops.. there was an error',
}
export enum errorsTranslatePtBrEnum {
  FACTOR_NOT_FOUND = 'Fatores não encontrado',
  TAXDATA_NOT_FOUND = 'Dados Fiscais não encontrado',
  INDEX_NOT_FOUND = 'Índice não encontrado',
  DETAILED_NOT_FOUND = 'Detalhamento não encontrado',
  MEMCALC_NOT_FOUND = 'Memória de cálculo não encontrada',
  FACTOR_DETAILED_NOT_FOUND = 'Fatores e detalhamento não encontrado',
  AUTHORS_NOT_FOUND = 'Ops.. Houve um erro!',
}
